import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {FileCardList} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$ce(2, 'div', '文件', 16, 'file-card-demo-loading-title'),
            _$cc(FileCardList, {
                'items': this.get('fileItems'),
                'overflow': 'scrollX'
            })
        ], 4, 'file-card-demo-loading-section'),
        _$ce(2, 'div', [
            _$ce(2, 'div', '图片', 16, 'file-card-demo-loading-title'),
            _$cc(FileCardList, {
                'items': this.get('imageItems'),
                'overflow': 'scrollX'
            })
        ], 4, 'file-card-demo-loading-section'),
        _$ce(2, 'div', [
            _$ce(2, 'div', '视频', 16, 'file-card-demo-loading-title'),
            _$cc(FileCardList, {
                'items': this.get('videoItems'),
                'overflow': 'scrollX'
            })
        ], 4, 'file-card-demo-loading-section'),
        _$ce(2, 'div', [
            _$ce(2, 'div', '音频', 16, 'file-card-demo-loading-title'),
            _$cc(FileCardList, {
                'items': this.get('audioItems'),
                'overflow': 'scrollX'
            })
        ], 4, 'file-card-demo-loading-section')
    ], 4, 'file-card-demo-loading');
};